module.exports = __webpack_public_path__ + "img/cardLayout-06.23fa53ce.png";